import React from 'react';
import { X, Smartphone, Wifi, WifiOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { WhatsAppQRCode } from '../../types/api';

interface WhatsAppQRModalProps {
  isOpen: boolean;
  onClose: () => void;
  qrData: WhatsAppQRCode | null;
}

const WhatsAppQRModal: React.FC<WhatsAppQRModalProps> = ({ isOpen, onClose, qrData }) => {
  console.log('🔍 WhatsAppQRModal render:', { isOpen, qrData: qrData ? 'present' : 'null' });
  
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-brand-slate/10">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <Smartphone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-heading text-brand-slate">
                    Conectar WhatsApp
                  </h3>
                  <p className="text-sm text-brand-ink/70">
                    Escaneie o QR Code com seu celular
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-brand-slate/10 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-brand-ink/70" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6">
              {qrData ? (
                <div className="text-center">
                  {/* QR Code Image */}
                  <div className="mb-6">
                    <img
                      src={qrData.base64}
                      alt="QR Code para conectar WhatsApp"
                      className="mx-auto rounded-lg shadow-lg max-w-xs w-full"
                    />
                  </div>

                  {/* Instructions */}
                  <div className="space-y-4">
                    <div className="flex items-center gap-3 text-brand-ink/80">
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-green-600 font-semibold text-sm">1</span>
                      </div>
                      <span className="text-sm">Abra o WhatsApp no seu celular</span>
                    </div>
                    
                    <div className="flex items-center gap-3 text-brand-ink/80">
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-green-600 font-semibold text-sm">2</span>
                      </div>
                      <span className="text-sm">Toque em Menu ou Configurações</span>
                    </div>
                    
                    <div className="flex items-center gap-3 text-brand-ink/80">
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-green-600 font-semibold text-sm">3</span>
                      </div>
                      <span className="text-sm">Toque em "Dispositivos conectados"</span>
                    </div>
                    
                    <div className="flex items-center gap-3 text-brand-ink/80">
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-green-600 font-semibold text-sm">4</span>
                      </div>
                      <span className="text-sm">Toque em "Conectar um dispositivo"</span>
                    </div>
                    
                    <div className="flex items-center gap-3 text-brand-ink/80">
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-green-600 font-semibold text-sm">5</span>
                      </div>
                      <span className="text-sm">Escaneie este QR Code</span>
                    </div>
                  </div>

                  {/* Status */}
                  <div className="mt-6 p-4 bg-brand-sand/50 rounded-lg">
                    <div className="flex items-center gap-2 text-brand-ink/70">
                      <WifiOff className="w-4 h-4" />
                      <span className="text-sm">Aguardando conexão...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-8">
                  <div className="w-16 h-16 bg-brand-slate/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Smartphone className="w-8 h-8 text-brand-slate/50" />
                  </div>
                  <p className="text-brand-ink/70">Carregando QR Code...</p>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-brand-slate/10 bg-brand-sand/30">
              <div className="flex items-center gap-2 text-xs text-brand-ink/60">
                <Wifi className="w-3 h-3" />
                <span>Certifique-se de que seu celular e computador estão na mesma rede</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppQRModal;
